/**
 * The languages of a trends summary: the locales the Music24 app ships
 * (`music24-app/src/i18n/locales`). music24-api refuses any other language, so a request can
 * never start a paid generation for a summary no client shows.
 */
export const TRENDS_SUMMARY_LANGUAGES = ['de', 'en', 'es', 'fr', 'it', 'nl', 'pl', 'pt', 'sv'] as const;

export type TrendsSummaryLanguage = (typeof TRENDS_SUMMARY_LANGUAGES)[number];

export const TRENDS_SUMMARY_FALLBACK_LANGUAGE: TrendsSummaryLanguage = 'en';

export function isTrendsSummaryLanguage(language: string): language is TrendsSummaryLanguage {
  return (TRENDS_SUMMARY_LANGUAGES as readonly string[]).includes(language);
}
